import { Delete } from '@bancobarigui/barihaus';
import { Flex, Tag, Text } from '@bancobarigui/barihaus';
import React from 'react';
import { Counter, Label, ProposalsGrid } from './styles';
import { counterFormat } from '../../utils/format-counter';
import { LoanTypeLabel } from '../../constants/loan-types';

interface ProposalListProps {
  index: number;
  todo: any;
  deleteTodoLoan: (index: number) => void;
}

const ProposalList = ({ index, todo, deleteTodoLoan }: ProposalListProps) => {
  return (
    <Flex key={index} vertical>
      <ProposalsGrid>
        <Counter style={{ margin: 'auto 0' }}>{counterFormat(index + 1)}</Counter>
        <Flex vertical>
          <Label>Tipo de empréstimo</Label>
          <Text fontSize={12} className="mt-1">
            {LoanTypeLabel[todo.loanType]}
          </Text>
        </Flex>
        <Flex vertical>
          <Label>Número da proposta</Label>
          <Text fontSize={12} className="mt-1">
            {todo.proposalNumber}
          </Text>
        </Flex>
        {todo.purchaseMargin !== undefined && todo.purchaseMargin > 0 && (
          <Flex vertical className="content-center">
            <Tag tagType="processing">Valor vinculado</Tag>
            <Text style={{ color: 'var(--colors-neutral-text-colortextqua-dark)', fontSize: '12px', margin: 'auto' }}>
              R$ {todo.purchaseMargin}
            </Text>
          </Flex>
        )}
        <button type="button" onClick={(): void => deleteTodoLoan(index)}>
          <Delete width={20} height={20} />
        </button>
      </ProposalsGrid>
    </Flex>
  );
};

export default ProposalList;
